import { render } from "./AmountInput.vue?vue&type=template&id=ba9d5354"
import script from "./AmountInput.vue?vue&type=script&lang=js"
export * from "./AmountInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__